import { render, staticRenderFns } from "./AffSubSourceBlacklist.vue?vue&type=template&id=307249f4"
import script from "./AffSubSourceBlacklist.vue?vue&type=script&lang=js"
export * from "./AffSubSourceBlacklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports